<template>

    <div class="TournamentsOverview content inner-grid-container">
        <div class="banner">
            <Banner v-bind:text="'MY TOURNAMENTS'"></Banner>
        </div>
        <div class="middle">
            <AddBox v-model="tournamentName" v-bind:placeholderText="placeholderText" v-on:add="createTournament"></AddBox>
            <TournamentCard v-for="tournament in reversedTournamentsList" :key="tournament.id" v-bind:tournament="tournament"></TournamentCard>
        </div>
    </div>
</template>


<script>
import Banner from "@/components/Banner.vue";
import TournamentCard from "@/components/TournamentCard.vue";
import AddBox from "@/components/AddBox.vue";
export default {
  name: "TournamentsOverview",

  components: {
    TournamentCard,
    AddBox,
    Banner
  },

  data: function() {
    return {
      tournamentName: "",
      placeholderText: "ENTER TOURNAMENT NAME"
    };
  },

  computed: {
    tournaments() {
      return this.$store.state.tournaments;
    },
    reversedTournamentsList() {
      return this.tournaments.slice().reverse()
    }
  },

  methods: {
    createTournament() {
      this.$store.dispatch("createTournament", this.tournamentName)
      this.tournamentName = ""
    }
  }
}
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/TournamentsOverview.vue